import api from './api'

class NewsletterService {
  static getPreferences() {
    return api
      .call('get', '/auth/newsletter/preferences')
      .then(api.getData)
      .then(data => (data && data.data) || data || {})
  }

  static updatePreferences(data) {
    return api
      .call('put', '/auth/newsletter/preferences', data )
      .then(api.getData)
      .then(result => (result && result.data) || result || {})
  }
}

export default NewsletterService
